
<template>
  <div>
    <IKFiltroFuncionario ref="ikFiltroFuncionario"/> 
    <h6 class="p-text-bold">Período</h6>  
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col">
            <label>Dia início</label>
            <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
        </div>
        <div class="p-field p-col">
            <label>Dia final</label>
            <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
        </div>
    </div>
   
    <h6 class="p-text-bold">Agrupar</h6>      
    <div class="p-formgroup-inline">        
        <div class="p-field-radiobutton">
            <RadioButton name="parametroGrupo" v-model="parametroGrupo" value="CENTRO_CUSTO"/>
            <label>Funcionários por Centro de Custo</label>
        </div>   
        <div class="p-field-radiobutton">
            <RadioButton name="parametroGrupo" v-model="parametroGrupo" value="MARCACOES" @click="listarRelogios"/>
            <label>Marcações por Local</label>
        </div>
    </div>

    <div class="p-fluid p-formgrid p-grid" v-if="parametroGrupo == 'MARCACOES'">
        <div class="p-field p-col">     
            <label>Local</label>       
            <Dropdown v-model.number="idRelogioSelecionado" :options="relogios" 
            optionLabel="localInstalacao" optionValue="id" placeholder="Selecione um local"/>			
        </div>        
    </div>
    <div class="p-d-flex p-jc-left">
        <Button label="Gerar PDF" icon="pi pi-file-pdf" class="p-mt-3 p-mr-2"
         @click="processarPdf" :disabled="bloquearEnivo"/> 
        <IKMonitoramentoDocumentos  ref="ikMonitoramentoDocumentos" :callback="finalizar"/>  
    </div>       
  </div>
</template>

<script>
import RelatorioService from '@/service/RelatorioService';
import RelogioPontoService from '@/service/RelogioPontoService.js';
import IKFiltroFuncionario from '@/components/template/IKFiltroFuncionario';
import IKMonitoramentoDocumentos from '@/components/template/IKMonitoramentoDocumentos';
import { exibirMensagem, exibirMensagemSis, preViewArquivo, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    relogioPontoService: null,
    relatorioService: null,
    data() {
        return {
            bloquearEnivo: false,
            dataFinal: new Date(),
            dataInicio: new Date(),
            rangeData: '',
            relogios: [],
            idRelogioSelecionado: null,
            parametroGrupo: 'CENTRO_CUSTO',
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        exportarPdf() {            
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();              
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            dados.funcionarios.forEach((funcio) => {
                idsFuncionarios.push(funcio.id);
            });
            let relogiosSelecionados = [];          
            if(this.parametroGrupo == 'MARCACOES') {
                if(this.idRelogioSelecionado > 0) {
                    for(let i = 0; i < this.relogios.length; i++) {
                        if(this.relogios[i].id == this.idRelogioSelecionado) {
                            relogiosSelecionados.push({id: this.relogios[i].id, localInstalacao: this.relogios[i].localInstalacao, numeroSerie: this.relogios[i].numeroSerie});
                            break;
                        }
                    }
                } else {
                   this.relogios.forEach(relogio => {
                    if(relogio.id > 0) {
                        relogiosSelecionados.push({id: relogio.id, localInstalacao: relogio.localInstalacao, numeroSerie: relogio.numeroSerie});
                    }                       
                   });
                }
            }
            let requisicao = {  
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),                
                nomeEmpresa: dados.cnpj.razaoSocial,
                tipoAgrupamento: this.parametroGrupo,
                relogios: relogiosSelecionados,
                idsFuncionarios: idsFuncionarios,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }            
            this.relatorioService.exportarFuncionariosMarcacaoRelogio(requisicao)
            .then(resp => {     
                preViewArquivo(resp.data);             
            })
            .catch(erro => {
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro)
            });
        },  
        processarPdf() {            
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();              
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            dados.funcionarios.forEach((funcio) => {
                idsFuncionarios.push(funcio.id);
            });
            let relogiosSelecionados = [];          
            if(this.parametroGrupo == 'MARCACOES') {
                if(this.idRelogioSelecionado > 0) {
                    for(let i = 0; i < this.relogios.length; i++) {
                        if(this.relogios[i].id == this.idRelogioSelecionado) {
                            relogiosSelecionados.push({id: this.relogios[i].id, localInstalacao: this.relogios[i].localInstalacao, numeroSerie: this.relogios[i].numeroSerie});
                            break;
                        }
                    }
                } else {
                   this.relogios.forEach(relogio => {
                    if(relogio.id > 0) {
                        relogiosSelecionados.push({id: relogio.id, localInstalacao: relogio.localInstalacao, numeroSerie: relogio.numeroSerie});
                    }                       
                   });
                }
            }
            let requisicao = {  
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),                
                nomeEmpresa: dados.cnpj.razaoSocial,
                tipoAgrupamento: this.parametroGrupo,
                relogios: relogiosSelecionados,
                idsFuncionarios: idsFuncionarios,
                idsCentrosCustos: dados.idsCentrosCustos,    
                cnpj: {...dados.cnpj},
                ativo: dados.ativo,
                todos: dados.todos,
                nomeDocumento: 'Marcações por Local ou Centro de Custo',
                nomeArquivo: 'Marcacoes_por_Local_ou_Centro_de_Custo',
                servico: 'marcacaoFuncionarioRelogioPonto',
                tipoDocumento: 'pdf',
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }            
            this.relatorioService.processar(requisicao)
            .then(resp => {     
                this.bloquearEnivo = true;
                this.$refs.ikMonitoramentoDocumentos.iniciarMonitoramento(resp.data);          
            })
            .catch(erro => {
                exibirMensagem(this, erro)
            });
        },  
        listarRelogios() {
            let cnpj = this.$refs.ikFiltroFuncionario.getCnpj();   
            if(cnpj == null) {
                setTimeout(() => { this.parametroGrupo = 'CENTRO_CUSTO'; }, 500);
                return;
            }          
			let requisicao = {
				cnpj: cnpj,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}            
			this.relogioPontoService.listar(requisicao)
			.then(resp => {	
                this.relogios = [];
                this.relogios.push({id: 0, localInstalacao: 'Todos'});
				resp.data.forEach(rel => {
                    this.relogios.push(rel);
                });
                this.idRelogioSelecionado = 0;
			})
			.catch(erro => {exibirMensagem(this, erro)});
		}, 
        /**
         * 
         */
        finalizar() {            
            this.bloquearEnivo = false;
        }, 
        /**
         * 
         * @param date 
         */   
        formatarData(date) {
            let ano = date.getFullYear();
            let mes = (date.getMonth() + 1) < 10 ? '0'+(date.getMonth() + 1) : (date.getMonth() + 1);
            let dia = date.getDate() < 10 ? '0'+date.getDate() : date.getDate();
            return ano+'-'+mes+'-'+dia;
        },
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
        },
    },
    created() {
        this.relogioPontoService = new RelogioPontoService();
        this.relatorioService = new RelatorioService();
    },
    mounted() {
        this.criarRangeData();
    },
    components: {
        'IKFiltroFuncionario': IKFiltroFuncionario,
        'IKMonitoramentoDocumentos': IKMonitoramentoDocumentos
    }
}
</script>

<style>

</style>